import * as Yup from 'yup'

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email('Deve ser um e-mail válido').required('Campo obrigatório'),
  resetClientURL: Yup.string(),
})

export default ForgotPasswordSchema